import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=f9d36ad6&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=f9d36ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d36ad6",
  null
  
)

export default component.exports